export default "__VITE_ASSET__ac027616__"